module.exports = __webpack_public_path__ + "fonts/fa-brands-400.d6ff69c8.woff";